import "jquery"
import "bootstrap"
import angular from "angular"
import "./index.less"
import "./r2/r2"

export default angular.module("app", ["r2"])

